var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWhoMen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "49px",
    viewBox: "0 0 20 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icWhoMen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.592962963 0.000602228245 8.6837037 0.000602228245 8.6837037 7.89924721 0.592962963 7.89924721 0.592962963 0.000602228245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 39.7469437 0 0.305209274 19.135679 0.305209274 19.135679 39.7469437 6.85314489e-16 39.7469437"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout--1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-566.000000, -451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Man",
    transform: "translate(566.000000, 451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(4.938272, 0.601927)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6262963,7.89924721 C5.7337037,7.89924721 6.7108642,7.54333032 7.49728395,6.80138512 C8.2837037,6.03836194 8.6837037,5.09527251 8.6837037,3.95947004 C8.6837037,2.87666366 8.27938272,1.9480277 7.49419753,1.18139115 C6.70530864,0.393074375 5.73061728,0.000421559771 4.6262963,0.000421559771 C3.46333333,0.000421559771 2.48493827,0.393074375 1.74851852,1.18139115 C0.963333333,1.9480277 0.592962963,2.87666366 0.592962963,3.95947004 C0.592962963,5.09828365 0.963333333,6.04077085 1.74851852,6.80138512 C2.48925926,7.54333032 3.46765432,7.89924721 4.6262963,7.89924721",
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 9.033123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93814815,0.305209274 L4.93814815,0.486479976 C3.70358025,0.486479976 2.44432099,0.998976212 1.41716049,1.98783499 C0.38691358,3.02246311 -0.00012345679,4.22451069 -0.00012345679,5.56446853 L-0.00012345679,17.9468835 C-0.00012345679,18.4105992 0.0665432099,18.8303523 0.43382716,19.1694068 C0.773950617,19.5042457 1.14864198,19.6560072 1.6282716,19.6560072 C2.17950617,19.6560072 2.44987654,19.5042457 2.78938272,19.1694068 C3.08444444,18.8303523 3.0862963,18.4105992 3.0862963,17.9468835 L3.0862963,6.92971996 L4.3208642,6.92971996 L4.3208642,37.5283348 C4.3208642,38.1185185 4.55666667,38.6635351 5.05851852,39.0832882 C5.53074074,39.5476061 6.06716049,39.7469437 6.7017284,39.7469437 C7.38876543,39.7469437 8.02950617,39.5494128 8.47888889,39.0832882 C8.95481481,38.6635351 9.2591358,38.1191207 9.2591358,37.5283348 L9.2591358,19.5765131 L9.87641975,19.5765131 L9.87641975,37.5283348 C9.87641975,38.1185185 10.222716,38.6635351 10.6696296,39.0832882 C11.1190123,39.5476061 11.7541975,39.7469437 12.4653086,39.7469437 C13.0683951,39.7469437 13.6437037,39.5494128 14.1196296,39.0832882 C14.5653086,38.6635351 14.8146914,38.1191207 14.8146914,37.5283348 L14.8146914,6.92971996 L15.4319753,6.92971996 L15.4319753,17.9468835 C15.4319753,18.4105992 15.735679,18.8303523 16.052963,19.1694068 C16.4307407,19.5042457 16.9449383,19.6560072 17.4208642,19.6560072 C17.9795062,19.6560072 18.3758025,19.5042457 18.6937037,19.1694068 C18.9801235,18.8303523 19.135679,18.4105992 19.135679,17.9468835 L19.135679,5.56507076 C19.135679,4.22932852 18.7011111,2.92911774 17.6702469,1.89990967 C16.6653086,0.906233062 15.5258025,0.305209274 14.0480247,0.305209274 L4.93814815,0.305209274 Z",
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhoMen);
export default __webpack_public_path__ + "static/media/icWhoMen.92fe26fa38c5e5503207b5f963fa188e.svg";
export { ForwardRef as ReactComponent };